module.exports = "<div *ngIf=\"visible\" class=\"popin\" (swipeleft)=\"changePhoto(-1)\" (swiperight)=\"changePhoto(1)\">\n\t<button (click)=\"closePopin()\" class=\"close\">close</button>\n\t<h1>{{current?.title}}</h1>\n\t<img [src]=\"'assets/images/'+current?.src\" [alt]=\"current?.title\" />\n\t<button (click)=\"changePhoto(-1)\" class=\"preview\">preview</button>\n\t<button (click)=\"changePhoto(1)\" class=\"next\">next</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/photo-viewer/photo-viewer.component.html
// module id = 598
// module chunks = 1